/**
 * Represents the possible display modes for a marker on the map.
 */
export default class MarkerMode {

  /**
   * It represents the Price display mode, showing the listing price on the pin.
   */
  static get Price() {
    return this.getInstance('price');
  }

  /**
   * It represents the Pin display mode, showing a standard pin without price.
   */
  static get Pin() {
    return this.getInstance('pin');
  }

  static fromKey(key) {
    const map = {
      price: MarkerMode.Price,
      pin: MarkerMode.Pin,
    };
    return map[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new MarkerMode(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(MarkerMode, 'instances', { value: {} });
